import { useContext, useEffect, useState } from "react";
import { useStylesMainPage } from "../styles/MainPageStyle";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AdminUserService,
  KS_customerservice_Service_Models_AdminUserDtos_TenantUserDto,
} from "../CustomerSvcService";
import TableComponent from "../components/table/TableComponent";
import { TABLE, TOAST } from "../utils/Enums";
import { Button, useToastController } from "@fluentui/react-components";
import { ToasterContext } from "../utils/GlobalContexts";
import { notify } from "../utils/DispatchToaster";

export default function UsersByTenantPage() {
  const styles = useStylesMainPage();
  const location = useLocation();
  const oid = location.state.oid;
  const tenant = location.state.tenant;
  const [users, setUsers] = useState<
    KS_customerservice_Service_Models_AdminUserDtos_TenantUserDto[] | null
  >();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toasterId } = useContext(ToasterContext);
  const { dispatchToast } = useToastController(toasterId);

  const navigateBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (oid) getData();
  }, [oid]);

  const getData = async () => {
    if (oid) setIsLoading(true);
    await AdminUserService.getApiAdminUser(oid)
      .then((res) => {
        if (res) {
          setUsers(res.tenants?.find((t) => t.id === tenant)?.users);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        notify(TOAST.ERROR, "Nem sikerült az adatok betöltése", dispatchToast);
        setIsLoading(false);
      });
  };

  return (
    <div className={styles.main}>
      <div className={styles.backButton}>
        <Button onClick={navigateBack}>Vissza</Button>
        <div
          className={styles.pageText}
        >{`${tenant} tenanthoz tartozó felhasználók`}</div>
      </div>
      <TableComponent
        type={TABLE.ADATPONT_USERS}
        data={users}
        isLoading={isLoading}
      />
    </div>
  );
}
